import AccountOverview from '../../assets/customSVG/accounts/AccountOverview.js';
import Teams from '../../assets/customSVG/accounts/Teams.js';
import Home from '../../assets/customSVG/navHome.js';
import Settings from '../../assets/customSVG/Settings.js';
import Webchat from '../../assets/customSVG/sideNav/Webchat.js';
import { ICONS } from '../../assets/icons/index.js';

export const navigationConst = [
  {
    id: 1,
    navName: 'Home',
    selected: false,
    routeUrl: '/user/home',
  },
  {
    id: 2,
    navName: 'Campaigns',
    selected: false,
    routeUrl: '/user/campaign',
  },

  {
    id: 3,
    navName: 'Products',
    selected: false,
    routeUrl: '/user/products',
  },

  {
    id: 4,
    navName: 'Calendar',
    selected: false,
    routeUrl: '/user/calendar',
  },

  {
    id: 5,
    navName: 'Inbox',
    selected: false,
    routeUrl: '/user/inbox',
    // subNav: [
    //   {
    //     id: 1,
    //     navName: "WhatsApp",
    //     icon: ICONS.whatsApp,
    //     selected: false,
    //     routeUrl: "/user/inbox",
    //   },
    //   {
    //     id: 2,
    //     navName: "Webchat",
    //     selected: false,
    //     routeUrl: "/user/webchat",
    //   },
    // ],
  },

  {
    id: 6,
    navName: 'CRM',
    selected: false,
    routeUrl: '/user/crm',
  },

  {
    id: 7,
    navName: 'Channels',
    selected: false,
    routeUrl: '/user/channels',
  },
  {
    id: 8,
    navName: 'Settings',
    selected: false,
    routeUrl: '/user/settings',
  },
  // {
  //   id: 9,
  //   navName: 'Webchat',
  //   selected: false,
  //   routeUrl: '/user/webchat',
  // },
  // {
  //   id: 10,
  //   navName: 'DataSources',
  //   selected: false,
  //   routeUrl: '/user/data-sources',
  // },
  {
    id: 11,
    navName: 'Agents',
    selected: false,
    routeUrl: '/user/agents',
  },
  // {
  //   id: 10,
  //   navName: "Agents",
  //   selected: false,
  //   routeUrl: "/user/agents",
  // },
];

export const accountNavigation = [
  {
    id: 1,
    navName: 'Brands',
    icon: AccountOverview,
    selected: false,
    routeUrl: '/profile/account/overview',
  },
  {
    id: 2,
    navName: 'Account Users',
    icon: Teams,
    selected: false,
    routeUrl: '/profile/account/account_users',
  },
  // {
  //   id: 3,
  //   navName: "Purchases",
  //   selected: false,
  //   icon: Purchases,
  //   routeUrl: "/profile/account/purchases",
  // },
  {
    id: 4,
    navName: 'Settings',
    selected: false,
    routeUrl: '/profile/settings',
    icon: Settings,
  },
];

export const profileBoxList = [
  {
    id: 2,
    icon: ICONS?.logout,
    name: 'Logout',
  },
];

export const WhatsappList = [
  {
    id: 1,
    name: 'Business account01',
  },
  {
    id: 2,
    name: 'Business account02',
  },
  {
    id: 3,
    name: 'Business account03',
  },
];
export const BusinessAccountList = [
  {
    id: 1,
    name: 'WhatsApp Account 1',
    subtitle: 'WhatApp Account ID: 123456789012345',
  },
  {
    id: 2,
    name: 'WhatsApp Account2',
    subtitle: 'WhatApp Account ID: 123456789012345',
  },
];

export const SignList = [
  {
    id: 1,
    name: 'First Name',
  },
  {
    id: 2,
    name: 'Last Name',
  },
];

export const ACCOUNT_SETTINGS_LIST = [
  {
    id: 1,
    name: 'Account',
    activeNav: '/account/overview',
    icon: Home,
  },
  {
    id: 2,
    name: 'Settings',
    activeNav: '/settings',
    icon: Settings,
  },
];
